import * as React from 'react';
import { SVGProps } from 'react';

const IconCloseSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m12 13.414 7.778 7.778 1.414-1.414L13.414 12l7.778-7.778-1.414-1.414L12 10.586 4.222 2.808 2.808 4.222 10.586 12l-7.778 7.778 1.414 1.414L12 13.414z" />
  </svg>
);

export default IconCloseSizeM;
